import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import { useProjects } from './_load/ProjectsLoader'
import { useOpenEditProjectModal } from '../../../utils/routes/modals/modalsActions'
import BigCardPicker from '../../../packages/kiti/components/form/BigCardPicker'

const useWidgetConfigs = () => {
  const { t } = useTranslation('projects')
  return useMemo(
    () => [
      {
        name: t('project.templates.createNew'),
        description: t('project.templates.newProjectDescription'),
        color: 'light5',
        icon: 'RiAddCircleLine',
        categories: [t('project.templates.new')]
      }
    ],
    [t]
  )
}

const useHandleSelectTemplate = () => {
  const openEditProject = useOpenEditProjectModal()

  return template => {
    openEditProject({
      id: template.id,
      fromTemplates: !!template.id,
      clone: !!template.id
    })
  }
}

const WidgetsList = () => {
  const { t } = useTranslation('projects')
  const templates = useProjects()
  const handleSelectTemplate = useHandleSelectTemplate()
  const widgetConfigs = useWidgetConfigs()

  return (
    <BigCardPicker
      onChange={handleSelectTemplate}
      options={[
        ...widgetConfigs,
        ...templates.map(item => ({
          ...item,
          color: item.color,
          icon: item.icon || 'RiDashboard3Line',
          categories: [t('project.templates.templates')],
          fromTemplates: true,
          clone: true
        }))
      ]}
    />
  )
}

export default WidgetsList
